import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import OfferCard from "../cards/OfferCard.tsx";
import { ComponentRef, useEffect, useRef } from "react";
import { useIntersectionObserver } from "usehooks-ts";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { useTaskCollectionListOptions } from "@/pages/get-don/tasks.api.ts";
import { getImageByPriority } from "@/shared/utils/common.ts";
export default function SpecialOfferSlider() {
  const { t } = useTranslation();
  const rootEl = useRef<ComponentRef<"div">>(null);
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0,
    root: rootEl.current,
  });

  const {
    data: tasks,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useSuspenseInfiniteQuery(useTaskCollectionListOptions({special:true}));

  // Fetch next page when the loader element is visible
  useEffect(() => {
    if (isIntersecting && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [isIntersecting, hasNextPage, isFetchingNextPage, fetchNextPage]);

  const taskList = tasks.pages.flatMap((page) => page.results);

  return (
    <div className="overflow-hidden -mx-4 px-4 " ref={rootEl}>
      <h2 className="text-lg text-white font-bold leading-130 mb-3">
        {t("special_offer")}
      </h2>
      <Swiper
        spaceBetween={12}
        className="!overflow-visible"
        slidesPerView="auto"
      >
        {taskList.map((task) => (
          <SwiperSlide className="!w-[97%]" key={task.id}>
            <OfferCard
              id={task.id}
              title={task.name}
              award={task.award}
              completedTasksCount={task.completed_tasks_count}
              taskCount={task.tasks_count}
              totalAward={task.total_award}
              bannerSrc={
                task.banner?.url
                  ? getImageByPriority(task.banner, "large")
                  : undefined
              }
              mode="light"
            />
          </SwiperSlide>
        ))}
        {(hasNextPage || isFetchingNextPage) && (
          <SwiperSlide className="!w-[97%]">
            <div
              ref={ref}
              className="m-0 flex items-center gap-2 relative group rounded-xl"
            >
              <div className="bg-white/08 h-[183px] w-full skeleton flex-center shrink-0 rounded-xl"></div>
            </div>
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  );
}